import styled from "styled-components";

export const DeviceTrackWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
`;
